/* storybook-check-ignore */

import { Button, Flex, Link, Text } from '@opendoor/bricks/core';
import pick from 'lodash/pick';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Listing } from '../../../declarations/exclusives/listing';
import { getMapLink } from '../../../helpers/exclusives/map';
import HomeSelfTourModal from './HomeSelfTourModal';
import useExclusiveAnalytics from '../hooks/useExclusiveAnalytics';
import { useListing } from '../hooks/useListing';
import MenuClose from '../icons/MenuClose';

interface Props {
  onOpenMapsClick?: () => void;
  onSelfTourClick?: () => void;
  onCloseClick: () => void;
  listing: Listing;
}

function HomeSelfTourNotification(props: Props) {
  const router = useRouter();
  const listing = useListing();
  const analytics = useExclusiveAnalytics();
  const [selfTourModalOpen, setSelfTourModalOpen] = useState(false);

  const reportEvent = (label: string) => {
    const fromQuery = pick(router.query, ['market', 'slug', 'source']);
    const payload = { ...fromQuery, type: listing?.exclusive_listing_info.state };
    analytics.trackExclusivesEvent('exclusives-open-house', label, undefined, payload);
  };
  if (props.listing.exclusive_listing_info.should_obfuscate_address) {
    return null;
  }

  return (
    <>
      <Flex
        flex={1}
        maxWidth="100vw"
        padding="1.5rem"
        gridGap="1.5rem"
        backgroundColor="neutrals0"
        flexDirection="column"
        borderBottom="1px solid var(--colors-neutrals40)"
      >
        <Flex flexDirection="column">
          <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
            <Text fontSize={['s1', 's2']} fontWeight="semibold" lineHeight={['s1', 's2']}>
              Take a Self Tour
            </Text>
            <Link
              analyticsName=""
              onClick={props.onCloseClick}
              aria-label="Close self tour Notification"
            >
              <MenuClose />
            </Link>
          </Flex>
          <Text fontSize={['s0', 's1']} lineHeight={['s0', 's1']} color="neutrals90">
            Make your way to the home and complete a short verification over the phone to access the
            home.
          </Text>
        </Flex>
        <Flex
          flex={1}
          flexDirection="row"
          justifyContent="space-between"
          gridGap="1rem"
          alignItems="center"
        >
          <Button
            as="a"
            aria-label={null}
            analyticsName="cosmos-exclusives-home-self-tour-notification-open-in-maps"
            onClick={() => reportEvent('routed')}
            href={getMapLink(props.listing)}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            variant="secondary"
            // @ts-expect-error TODO @exclusives to resolve
            borderRadius="rounded"
            maxWidth="10rem"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            overflow="hidden"
          >
            Open in Maps
          </Button>
          <Button
            aria-label={null}
            onClick={() => {
              reportEvent('schedule-tour-viewed');
              setSelfTourModalOpen(true);
            }}
            analyticsName="cosmos-exclusives-home-self-tour-notification-button"
            size="sm"
            variant="primary"
            // @ts-expect-error Bricks intentionally doesn't allow customization of border radii on buttons. Product teams should resolve this violation
            borderRadius="rounded"
            maxWidth="10rem"
          >
            Self tour
          </Button>
        </Flex>
      </Flex>
      {selfTourModalOpen && (
        <HomeSelfTourModal
          aria-label="Self Tour formulary"
          listing={props.listing}
          isOpen={selfTourModalOpen}
          analyticsName="cosmos-exclusives-home-self-tour-modal"
          onRequestClose={() => setSelfTourModalOpen(false)}
        />
      )}
    </>
  );
}

export default HomeSelfTourNotification;
